import CreateBlurImage from 'Components/01-components/feature-image';

(function (Drupal) {
  Drupal.behaviors.featureImage = {
    attach: function (context, settings) {
      context.querySelectorAll('.feature-image--page_banner').forEach(CreateBlurImage);
    }
  };
}(Drupal));
